import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Reveal } from "../common/Reveal";
import { Img } from "../common/Img";
import { JOURNEY } from "../../data/qualityJourney";
import { useLanguage } from "../../context/LanguageContext";

export default function QualityJourney() {
  const { t, localize } = useLanguage();
  const [active, setActive] = useState(0);
  const stage = JOURNEY[active];

  return (
    <section className="bg-[#F6F2EC] py-24 md:py-32" data-testid="journey-section">
      <div className="container-tessa">
        <Reveal className="mb-14">
          <span className="font-sans text-xs uppercase tracking-[0.24em] text-[#D92A47]">
            {t("journey.eyebrow")}
          </span>
          <h2 className="mt-4 font-serif text-4xl leading-[1.0] text-[#183C32] md:text-5xl lg:text-6xl">
            {t("journey.title1")}
            <br />
            <span className="italic text-[#D92A47]">{t("journey.title2")}</span>
          </h2>
        </Reveal>

        <div className="mb-14 grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-14">
          <div className="relative order-2 aspect-[4/3] overflow-hidden lg:order-1">
            <AnimatePresence mode="wait">
              <motion.div
                key={stage.id}
                initial={{ opacity: 0, scale: 1.04 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.6 }}
                className="absolute inset-0"
              >
                <Img
                  src={stage.image}
                  alt={localize(stage, "name")}
                  className="h-full w-full object-cover"
                />
              </motion.div>
            </AnimatePresence>
          </div>
          <div className="order-1 lg:order-2">
            <AnimatePresence mode="wait">
              <motion.div
                key={`${stage.id}-text`}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
              >
                <span className="font-serif text-7xl text-[#D9A9AE]">{stage.num}</span>
                <h3 className="mt-2 font-serif text-3xl text-[#252525] md:text-4xl">
                  {localize(stage, "name")}
                </h3>
                <p className="mt-4 max-w-md leading-relaxed text-[#817B74]">
                  {localize(stage, "desc")}
                </p>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>

        <div className="relative flex flex-col gap-4 border-t border-black/10 pt-2 md:flex-row md:gap-0">
          {JOURNEY.map((item, index) => (
            <button
              key={item.id}
              onClick={() => setActive(index)}
              data-testid={`journey-step-${item.id}`}
              aria-current={active === index}
              className="group relative flex-1 py-4 text-left md:pr-6"
            >
              <span
                className={`absolute -top-[2px] left-0 h-[2px] bg-[#D92A47] transition-all duration-500 ${
                  active === index ? "w-full" : "w-0 group-hover:w-1/3"
                }`}
              />
              <div className="flex items-baseline gap-3">
                <span
                  className={`font-serif text-xl ${
                    active === index ? "text-[#D92A47]" : "text-[#817B74]"
                  }`}
                >
                  {item.num}
                </span>
                <span
                  className={`font-sans text-sm uppercase tracking-[0.1em] ${
                    active === index ? "text-[#252525]" : "text-[#817B74]"
                  }`}
                >
                  {localize(item, "name")}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
